module.exports = __webpack_public_path__ + "img/milestone__1919.a0cf6489.jpg";